import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

/**
 * @typedef {object} Props
 * @property {string} sku
 */

/** @type {React.FunctionComponent<Props>} */
const Sku = ({ sku }) => {
  return (
    <span className="sku">
      <FormattedMessage
        id="components.atoms.Typography.Sku.label"
        defaultMessage={`SKU`}
      />
      &nbsp;
      {sku}
    </span>
  );
};

Sku.propTypes = {
  sku: PropTypes.string,
};

export default Sku;
